import get from 'lodash/get'
import { GET_VOYAGE_DATA,IS_PAST_VOYAGE,PAST_VOYAGE_LIST } from './../constants/actionTypes'
import { saveActiveVoyageToStorage } from '../helpers/util'

export const getVoyage = data => (dispatch, getState) => {
  const shipCode = get(getState(), 'ship', '')
  saveActiveVoyageToStorage(data, shipCode)
  dispatch({
    type: GET_VOYAGE_DATA,
    data
  })
}
export const isPastVoyage = data => dispatch => {
  dispatch({
    type: IS_PAST_VOYAGE,
    data
  })
}
export const getPastVoyageList = data => dispatch => {
  dispatch({
    type: PAST_VOYAGE_LIST,
    data
  })
}
